import React from 'react';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-content">
        <span className="muted">© 2026 • Personal CV</span>
        <a href="#home" className="back-to-top">Lên đầu trang ↑</a>
      </div>
    </footer>
  );
}

export default Footer;



